import React from 'react';

import { Toast, Radio, WingBlank, Button } from 'antd-mobile'
class App extends React.Component {
    state = {
        qValue0:  0,
        qValue1:  0,
        qValue2:  0,
        qValue3:  0,
        qValue4:  0,
        qValue5:  0,
        qValue6:  0,
        qValue7:  0,
        qValue8:  0,
        qValue9:  0,
        qValue10: 0,
        qValue11: 0,
        qValue12: 0,
        qValue13: 0,
        qValue14: 0,
        qValue15: 0,
        qValue16: 0,
        qValue17: 0,
        qValue18: 0,
        qValue19: 0,
    }
    createQuestionList() {
        let questionJson = [
            {
                q: "1.我觉得闷闷不乐，情绪低沉。",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "2.我觉得一天之中早晨最好。",
                a: [{ value: 4, text: "A.很少" }, { value: 3, text: " B.小部分时间" }, { value: 2, text: " C.相当多的时间" }, { value: 1, text: " D.绝大部分时间" }]
            },
            {
                q: "3.我一阵阵哭出来或觉得想哭。",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "4.我晚上睡眠不好。",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "5.我吃得跟平常一样多。",
                a: [{ value: 4, text: "A.很少" }, { value: 3, text: " B.小部分时间" }, { value: 2, text: " C.相当多的时间" }, { value: 1, text: " D.绝大部分时间" }]
            },
            {
                q: "6.我与异性密切接触时和以往一样感到愉快。",
                a: [{ value: 4, text: "A.很少" }, { value: 3, text: " B.小部分时间" }, { value: 2, text: " C.相当多的时间" }, { value: 1, text: " D.绝大部分时间" }]
            },
            {
                q: "7.我发觉我的体重在下降。",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "8.我有便秘的苦恼。",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "9.我心跳比平时快。",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "10.我无缘无故的感到疲乏。",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "11.我的头脑跟平常一样清楚。",
                a: [{ value: 4, text: "A.很少" }, { value: 3, text: " B.小部分时间" }, { value: 2, text: " C.相当多的时间" }, { value: 1, text: " D.绝大部分时间" }]
            },
            {
                q: "12.我觉得经常做的事情并没有困难。",
                a: [{ value: 4, text: "A.很少" }, { value: 3, text: " B.小部分时间" }, { value: 2, text: " C.相当多的时间" }, { value: 1, text: " D.绝大部分时间" }]
            },
            {
                q: "13.我觉得不安而平静不下来。",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "14.我对将来抱有希望。",
                a: [{ value: 4, text: "A.很少" }, { value: 3, text: " B.小部分时间" }, { value: 2, text: " C.相当多的时间" }, { value: 1, text: " D.绝大部分时间" }]
            },
            {
                q: "15.我比平常容易生气激动。",

                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "16.我觉得作出决定是容易的。",
                a: [{ value: 4, text: "A.很少" }, { value: 3, text: " B.小部分时间" }, { value: 2, text: " C.相当多的时间" }, { value: 1, text: " D.绝大部分时间" }]
            },
            {
                q: "17.我觉得自己是个有用的人，有人需要我。",
                a: [{ value: 4, text: "A.很少" }, { value: 3, text: " B.小部分时间" }, { value: 2, text: " C.相当多的时间" }, { value: 1, text: " D.绝大部分时间" }]
            },
            {
                q: "18.我的生活过的很有意思。",
                a: [{ value: 4, text: "A.很少" }, { value: 3, text: " B.小部分时间" }, { value: 2, text: " C.相当多的时间" }, { value: 1, text: " D.绝大部分时间" }]
            },
            {
                q: "19.我认为如果我死了别人会生活得好些。",
                a: [{ value: 1, text: "A.很少" }, { value: 2, text: " B.小部分时间" }, { value: 3, text: " C.相当多的时间" }, { value: 4, text: " D.绝大部分时间" }]
            },
            {
                q: "20.平常感兴趣的事我仍然照样感兴趣。",
                a: [{ value: 4, text: "A.很少" }, { value: 3, text: " B.小部分时间" }, { value: 2, text: " C.相当多的时间" }, { value: 1, text: " D.绝大部分时间" }]
            },
        ]
        let questionList = questionJson.map((row, qIndex) => {
            return (
                <li key={qIndex}>
                    <div className="question_title">{row.q}</div>
                    <div className="answer">
                        {
                            row.a.map((a, aIndex) => {
                                return (
                                    <div key={aIndex}>
                                        <Radio className="xu_radio" onChange={() => { this.onChange(a.value, qIndex) }} checked={this.state["qValue" + qIndex] === a.value} name={"q" + qIndex} key={a.value}>{a.text}</Radio>
                                    </div>
                                )
                            })
                        }
                    </div>
                </li>
            )
        })
        return questionList
    }
    onChange(value, index) {
        let state = JSON.parse(JSON.stringify(this.state))
        state['qValue' + index] = value
        this.setState(state)
    }
    onSubmit() {
        let state = this.state
        let keys = Object.keys(state)
        let flag = keys.filter(key => {
            return state[key] === 0
        })
        if (flag.length !== 0) {
            Toast.info("题目还没有做完撒~")
        } else {
            //开始算分啦
            let totalScore = 0;
            keys.forEach(key => {
                totalScore += state[key]
            })
            let standerScore = parseInt(totalScore * 1.25)
            if (standerScore < 53) {
                Toast.success('你没有抑郁症')
            } else if (standerScore >= 53 && standerScore < 62) {
                Toast.fail('你患有轻度抑郁')
            } else if (standerScore >= 63 && standerScore < 72) {
                Toast.fail('你患有中度抑郁')
            } else if (standerScore > 72) {
                Toast.fail('你患有重度抑郁')
            }
        }
    }
    render() {
        return (
            <div className="question_page">
                <WingBlank>
                    <h1 className='title'>抑郁自评量表（SDS）</h1>
                    <p className='desc'></p>
                    {/* <h3 className='time'></h3> */}
                    <ul className="question_list">
                        {this.createQuestionList()}
                    </ul>

                    <Button type="primary" onClick={this.onSubmit.bind(this)}>提交</Button>
                </WingBlank>
            </div>
        );
    }
}

export default App;
